import React from "react";
import Introduction from "@components/aboutUs/introduction";
import WhyPeople from "@components/aboutUs/whyPeople";
import OurTeam from "@components/aboutUs/ourTeam";
import WhySeveral from "@components/aboutUs/whySeveral";
import { translate } from "@helpers/translationObjectFormatter";
import { ICustomDomain, TranslationsObject } from "@genericTypes/sharedTypes";
import { GetStaticPropsContext } from "next";
import MetaTags from "@components/shared/metaTags";
import { GQLPosts } from "@gql/types/gql";
import ListOfLinks from "@components/shared/listOfLinks";

import { useQuery } from "@tanstack/react-query";
import { GQLDomains } from "@gql/types/gql";
import { getKeyWordsForMetaTags } from "@lib/sharedUtils";
import initialCall from "@helpers/initial-call";
const AboutUsPage = () => {
    const { data: recentPosts } = useQuery<GQLPosts, Error>(["recentPosts"]);
    const { data: domainInfo } = useQuery<ICustomDomain, Error>({
        queryKey: ["domain"],
    });
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <>
            <MetaTags
                title={translate(
                    translations,
                    "several_aboutUsPage_meta_title",
                )}
                description={translate(
                    translations,
                    "several_aboutUsPage_meta_description",
                )}
                keyWords={
                    getKeyWordsForMetaTags(
                        domainInfo?.domain as GQLDomains,
                    ) as string
                }
            />
            <section className="max-w-7xl mx-auto px-5">
                <Introduction />
                <WhyPeople />
                <OurTeam />
                <WhySeveral />
                <div className="lg:mt-36 mt-20 lg:mb-48 mb-20">
                    <ListOfLinks
                        title={translate(
                            translations,
                            "several_general_readInOurBlog",
                        )}
                        items={recentPosts as { title: string; link: string }[]}
                    />
                </div>
            </section>
        </>
    );
};

export const getStaticProps = async (ctx: GetStaticPropsContext) => {
    return await initialCall("AboutUs", ctx);
};

export default AboutUsPage;
